import PropTypes from 'prop-types';
import React from 'react';
import compose from 'recompose/compose';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import styles from './Logo.css';

const Logo = ({
  logo,
  companyName,
  className,
  style,
  onboarding,
  placeholderHeight,
}) => {
  if (logo) {
    return (
      <img
        className={cx(styles.logo, className)}
        style={style}
        src={!onboarding ? logo : '/img/jobzology2x.png'}
        alt={`${companyName} Logo`}
        title={`${companyName} Logo`}
      />
    );
  }
  if (
    typeof placeholderHeight === 'number' ||
    (typeof placeholderHeight === 'string' && placeholderHeight !== '')
  ) {
    const height = typeof placeholderHeight === 'number' ? `${placeholderHeight}px` : placeholderHeight;
    return <div style={{ height }} aria-hidden="true" />;
  }
  return null;
};

Logo.propTypes = {
  logo: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  companyName: PropTypes.string,
  className: PropTypes.string,
  onboarding: PropTypes.bool,
  style: PropTypes.object,
  placeholderHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Logo.defaultProps = {
  style: {},
};

export default compose(
  withRouter,
  connect(({ theme }, { location }) => ({
    onboarding: ('token' in queryString.parse(location.search)),
    logo: theme.logo,
    companyName: theme.companyName,
  })),
)(Logo);



// WEBPACK FOOTER //
// ./src/client/Components/Logo/Logo.js